import { BOARD_SIZE } from "./state";
export function otherOthelloSide(side) {
    if (side === "black") {
        return "white";
    }
    return "black";
}
export function parseMessage(message) {
    // console.log("debug, parsing message:", message);
    if (message.LobbyCreated) {
        return { type: "LobbyCreated", lobbyId: message.LobbyCreated };
    }
    if (message.LobbyJoined) {
        return {
            type: "LobbyJoined",
            yourSide: message.LobbyJoined.your_side.toLowerCase(),
        };
    }
    if (message === "QuickPlayJoined") {
        return { type: "QuickPlayJoined" };
    }
    if (message === "GameStarted") {
        return { type: "GameStarted" };
    }
    if (message.GameStateUpdated) {
        const gameState = {
            currentSide: message.GameStateUpdated.current_turn === "White"
                ? "white"
                : "black",
            board: [],
        };
        for (let y = 0; y < BOARD_SIZE; ++y) {
            for (let x = 0; x < BOARD_SIZE; ++x) {
                const val = message.GameStateUpdated.board.cells[y][x];
                gameState.board.push(val.Occupied != null
                    ? val.Occupied.toLowerCase()
                    : "unoccupied");
            }
        }
        return { type: "GameStateUpdated", state: gameState };
    }
    if (message.YourTurn) {
        return { type: "YourTurn", validMoves: message.YourTurn.valid_moves };
    }
    if (message.GameOver) {
        return {
            type: "GameOver",
            status: {
                reason: message.GameOver.reason,
                blackCells: message.GameOver.cell_counts.black_cells,
                whiteCells: message.GameOver.cell_counts.white_cells,
            },
        };
    }
    if (message.PlayerDisconnected) {
        return { type: "PlayerDisconnected", side: message.PlayerDisconnected };
    }
    if (message.PlayerJoined) {
        return { type: "PlayerJoined", side: message.PlayerJoined };
    }
    if (message.Error) {
        return { type: "Error", error: message.Error };
    }
    if (message.Text) {
        return { type: "Text", text: message.Text };
    }
    throw { type: "couldn't parse message", message };
}
